import React, { Component } from 'react'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'
import {
  AreaChart,
  // Label,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Area,
  ResponsiveContainer
} from 'recharts'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import classes from './style.scss'
import { Grid, Typography } from '@material-ui/core/'
class ForceRankChart extends Component {
  state = {
    gradeData: [],
    grade: [],
    adjust_grade: []
  }

  render() {
    let data = []
    if (this.props.gradeData[0]?.adjust_grade) {
      this.props.gradeOptions.map(item => {
        data.push({ adjust_grade: item.label, total: 0 })
        return item
      })
      this.props.gradeData.map(item => {
        let check = data.find(d => d.adjust_grade === item.adjust_grade.label)
        if (check) {
          data = data.map(d => {
            if (d.adjust_grade === item.adjust_grade.label) {
              return {
                adjust_grade: d.adjust_grade,
                total: d.total + 1
              }
            } else {
              return d
            }
          })
        } else {
          data.push({ adjust_grade: item.adjust_grade.label, total: 1 })
        }

        return {
          ...item,
          adjust_value: item.adjust_grade.label
        }
      })
    }
    return (
      <Aux>
        <Grid container direction={'row'} spacing={1}>
          <Grid item>
            <Typography>
              {this.props.translate('adjust')} {this.props.translate('grade')}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} className={classes.areaChart}>
            <ResponsiveContainer>
              <AreaChart
                width={500}
                height={400}
                data={data}
                margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                <defs>
                  <linearGradient id='color' x1='0' y1='0' x2='0' y2='1'>
                    <stop offset='5%' stopColor='#98cad3' stopOpacity={0.8} />
                    <stop offset='95%' stopColor='#98cad3' stopOpacity={0} />
                  </linearGradient>
                </defs>
                <XAxis dataKey='adjust_grade'>
                  {/* <Label value={this.props.translate('grade')} offset={0} position='insideBottom' /> */}
                </XAxis>
                <YAxis>
                  {/* <Label value={this.props.translate('adjust')} angle={-90} position='insideLeft' /> */}
                </YAxis>

                <CartesianGrid strokeDasharray='3 5' />
                <Tooltip />
                <Area
                  type='monotone'
                  dataKey='total'
                  stroke='#98cad3'
                  fillOpacity={1}
                  fill='url(#color)'
                />
              </AreaChart>
            </ResponsiveContainer>
          </Grid>
        </Grid>
      </Aux>
    )
  }
}

export default withTranslate(ForceRankChart)
